// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__MVV7a","white":"radio_white__9jJIC","ecommerceRadioPrimary":"radio_ecommerceRadioPrimary__pVR-i"};